import { parse, isValid, getUnixTime, format, isDate, isAfter, addMonths, addDays } from 'date-fns'
import { ptBR } from 'date-fns/locale'
// import { enGB } from 'date-fns/locale'
// import ptBR from 'date-fns/locale/pt-BR'

const devBaseName  = process.env.REACT_APP_BASENAME_DEV
const prodBaseName = process.env.REACT_APP_BASENAME 
const buildPath    = process.env.PUBLIC_URL

// Constants

export const ONLYLETTERS   = /[^A-zÀ-ú ]|\d+$/
export const ONLYNUMBERS   = /[^0-9.]+/g
export const ONLYPHONE     = /^([0-9]{4,5})([0-9]{4})$/
export const ONLYDDD       = /^([0-9]{2})$/
export const ONLYEMAIL     = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi


/**
 * Aplica máscara ao CPF
 * 
 * @param {string} cpf
 * @returns {string}
 */
export function mascararCpf(cpf) {
    // Remove todos os caracteres não numéricos
    cpf = cpf?.replace(/\D/g, '');

    // Aplica a máscara se o CPF tiver 11 dígitos
    if (cpf?.length === 11) {
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    // Retorna o CPF original se não tiver 11 dígitos
    return cpf;
}

// Function to normalize specialty description
const normalizeSpecialty = (specialty) => {
    return specialty.toLowerCase().replace(ONLYLETTERS, '')
}

// Function to filter data by specialty
const filterBySpecialty = (data, specialty) => {
    const normalizedSpecialty = normalizeSpecialty(specialty.descricaoEspecialidade)
    return data.filter(item => {
        return normalizeSpecialty(item.descricaoEspecialidade) === normalizedSpecialty
    })
}

// Function to convert date to Unix time
const convertToUnixTime = (dateString) => {
    const date = parse(dateString, 'dd/MM/yyyy', new Date())
    return getUnixTime(date)
}

// Main function to get return appointments
export const getRetornoAtendimentos = (data, especialidade) => {
    if (!data || data.length === 0) return []
    
    const filteredData = filterBySpecialty(data, especialidade)
    return filteredData.map(item => convertToUnixTime(item.dataPrazoRetorno))
}

// const typeDevices = {
//     "Windows NT 10.0": "Windows 10",
//     "Windows NT 6.3" : "Windows 8.1",
//     "Windows NT 6.2" : "Windows 8",
//     "Windows NT 6.1" : "Windows 7",
//     "Windows NT 6.0" : "Windows Vista", 
//     "Windows NT 5.1" : "Windows XP",
//     "Windows NT 5.0" : "Windows 2000", 
//     "Mac"            : "Mac/iOS",
//     "X11"            : "UNIX",
//     "Linux"          : "Linux"
// }



export const SITE_URL      = process.env.REACT_APP_SITE_URL

export const ACOR_TELEFONE = process.env.REACT_APP_ACOR_TELEFONE

export const ACOR_WHATSAPP = process.env.REACT_APP_ACOR_WHATSAPP

export const CLIENT        = process.env.REACT_APP_ALIAS_EMPRESA ?? ''

export const BASENAME      = buildPath === devBaseName ? devBaseName : prodBaseName

export const ENVORIMENT    = process.env.NODE_ENV 

export const isProduction  = BASENAME === '/agendamento' && ENVORIMENT !== 'development'

export function parseDateString(_, originalValue) {
    try {
        // Verifica se originalValue é uma data válida
        if (isDate(originalValue) || !isNaN(new Date(originalValue).getTime())) {
            return originalValue
        }

        // Verifica o formato da data
        let parsedDate;
        if (originalValue.includes('/')) {
            // Formato dd/MM/yyyy
            parsedDate = parse(originalValue, "dd/MM/yyyy", new Date())
        } else {
            // Formato yyyy-MM-dd
            parsedDate = parse(originalValue, "yyyy-MM-dd", new Date())
        }

        // Verifica se a data parseada é inválida
        if (!isDate(parsedDate) || isNaN(parsedDate.getTime())) {
            throw new Error('Data inválida')
        }

        return parsedDate
    } catch (error) {
        console.error('Erro ao parsear a data:', error)
        throw error // Lança uma exceção em caso de erro na conversão
    }
}

export const addOneMonthAppoitaments = (appoitamments) => {

    const appoitammentsDates = appoitamments.map( appoitament => {
                
        const dateSchedule = convertDateFormat(appoitament.dataAgenda)

        return addMonths(new Date(dateSchedule), 1) 
        
    })

    return appoitammentsDates
}

export const getDateAvailable = (date, appoitamments, quantidade) =>  {
                
    const datesAfter = appoitamments
        .reverse()
        .reduce( (acc, d) => { 
        
            const dataAgenda = convertDateFormat(date.dataAgenda, "dd/MM/yyyy") 

            if (isAfter(new Date(d), new Date(dataAgenda)) && quantidade ) { acc.push(d) }

            return acc
        
        }, []) 
    
    if (!quantidade) return date

    return quantidade >= datesAfter.length ? date : false     
         
}

// Helper function to check if a date exists in the array
const dateExists = (acc, date) => {
    return acc.some(ac => ac.dataAgenda === date)
}

// Main function to get unique days
export const getUniqueDays = (days) => {
    if (!Array.isArray(days) || days.length === 0) return []

    return days.reduce((acc, item) => {
        if (!dateExists(acc, item.dataAgenda)) {
            acc.push(item)
        }
        return acc
    }, [])
}

export const getDaysFromLimit = ( items ) => {
    // Data limite
    const LimitDays = process.env.REACT_APP_LIMITA_DIAS_AGENDA
    
    if (!LimitDays) {
       return items
    }
        
    const dayLimit = addDays(new Date(), LimitDays)
    
    const filterDaysByLimit = ( item ) => {
        const dataAgenda = parse(item.dataAgenda, 'dd/MM/yyyy', new Date())
        return !isAfter(dataAgenda, dayLimit)
    }

    // const arrayTest = [
    //     {
    //         "idAgenda": "2768157",
    //         "dataAgenda": "06/05/2024",
    //         "diaSemana": "Terça-feira",
    //         "horarioAgenda": "11:20",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "527",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768158",
    //         "dataAgenda": "07/05/2024",
    //         "diaSemana": "Terça-feira",
    //         "horarioAgenda": "11:20",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768197",
    //         "dataAgenda": "08/05/2024",
    //         "diaSemana": "Quarta-feira",
    //         "horarioAgenda": "09:50",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768236",
    //         "dataAgenda": "09/05/2024",
    //         "diaSemana": "Quinta-feira",
    //         "horarioAgenda": "08:20",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768287",
    //         "dataAgenda": "10/05/2024",
    //         "diaSemana": "Sexta-feira",
    //         "horarioAgenda": "08:50",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768330",
    //         "dataAgenda": "13/05/2024",
    //         "diaSemana": "Segunda-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768378",
    //         "dataAgenda": "14/05/2024",
    //         "diaSemana": "Terça-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768427",
    //         "dataAgenda": "15/05/2024",
    //         "diaSemana": "Quarta-feira",
    //         "horarioAgenda": "08:10",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768474",
    //         "dataAgenda": "16/05/2024",
    //         "diaSemana": "Quinta-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768523",
    //         "dataAgenda": "17/05/2024",
    //         "diaSemana": "Sexta-feira",
    //         "horarioAgenda": "08:10",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768571",
    //         "dataAgenda": "20/05/2024",
    //         "diaSemana": "Segunda-feira",
    //         "horarioAgenda": "08:10",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768618",
    //         "dataAgenda": "21/05/2024",
    //         "diaSemana": "Terça-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768666",
    //         "dataAgenda": "22/05/2024",
    //         "diaSemana": "Quarta-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768714",
    //         "dataAgenda": "23/05/2024",
    //         "diaSemana": "Quinta-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768762",
    //         "dataAgenda": "24/05/2024",
    //         "diaSemana": "Sexta-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768811",
    //         "dataAgenda": "27/05/2024",
    //         "diaSemana": "Segunda-feira",
    //         "horarioAgenda": "08:10",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768858",
    //         "dataAgenda": "28/05/2024",
    //         "diaSemana": "Terça-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768907",
    //         "dataAgenda": "29/05/2024",
    //         "diaSemana": "Quarta-feira",
    //         "horarioAgenda": "08:10",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2768954",
    //         "dataAgenda": "30/05/2024",
    //         "diaSemana": "Quinta-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2769050",
    //         "dataAgenda": "03/06/2024",
    //         "diaSemana": "Segunda-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2769098",
    //         "dataAgenda": "04/06/2024",
    //         "diaSemana": "Terça-feira",
    //         "horarioAgenda": "08:00",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     },
    //     {
    //         "idAgenda": "2769147",
    //         "dataAgenda": "05/06/2024",
    //         "diaSemana": "Quarta-feira",
    //         "horarioAgenda": "08:10",
    //         "descricaoUnidade": "*REPUBLICA",
    //         "idProfissional": "3692",
    //         "nomeProfissional": "FERNANDO ISNARD ABRAHAO",
    //         "idAgCad": "528",
    //         "tipoRestricao": null
    //     }
    // ]

    return items?.filter(filterDaysByLimit)

} 

export const getUniqueDaysFromSchedule = (data, daysNotReturn) => {
    
    const response = data?.reduce( (acc, item) => {
            
        const dataAgendaUnix = getUnixTimeFromDate(item.dataAgenda)
        
        const IsOutReturn = daysNotReturn.every( dataPrazoRetorno => {  
            return dataAgendaUnix > dataPrazoRetorno   
        })

        IsOutReturn && acc.push(item)

        return acc

    }, [] )

    return response

}

// export const getDatesDoctor = (currentDate, appoitammentsDates, quantidade)
//     .reduce( (acc, iDate) =>  {
        
//         const datesAvailable = getDateAvailable(iDate, appoitammentsDates, quantidade) 
        
//         if (datesAvailable) {
//             acc.push(datesAvailable) 
//         }

//         return acc
        
//     }, [])

// export const getRetornoAtendimentos = (data, especialidade) => {
    
//     if (!data || data.length === 0) return []

//     const retornos = data.filter( r => { 
    
//         const atendimentosEspecialidade = r
//             .descricaoEspecialidade
//             .toLowerCase()
//             .replace(ONLYLETTERS, '')

//         const currentEspecialidade = especialidade
//             .descricaoEspecialidade
//             .toLowerCase()
//             .replace(ONLYLETTERS, '')
          
//         return atendimentosEspecialidade === currentEspecialidade
//     })
    
//     return retornos.reduce( (acc, r) => {

//         const date = parse(r.dataPrazoRetorno, 'dd/MM/yyyy', new Date())
        
//         const unixDate = getUnixTime(date)

//         acc.push(unixDate)

//         return acc

//     }, [])
// }



// export const getDataNotNull = data => {

//     if (data?.length > 0) {
//         console.log(data, 'getDataNotNull')
//         const keys = Object.keys(data[0])

        
        
//         const res = keys.reduce( (acc, k) => { 
            
//             if (data[0][k] !== undefined) {
//                 const value = data[0][k]
//                 return {...acc, [k]: value }
//             }

//             return acc
        
//         }, {}) 

//         if (data[0]?.cpf) {
//             return {userExists: !!data?.length, cpfPaciente: data[0].cpf, ...res}
//         }

//         if (data[0]?.dataNascimento) {
//             return {userExists: !!data?.length, cpfPaciente: data[0].cpf, dataNascimentoPaciente: data[0].dataNascimento,  ...res}
//         }

//         return {userExists: !!data?.length, ...res} 

        
//     }

//     return data
// }

// Helper function to extract non-null values from an object
const getNonNullValues = (obj) => {
   
    return Object.keys(obj).reduce((acc, key) => {
        
        if (obj[key] !== undefined) {
            acc[key] = obj[key]
        }
        return acc
    }, {})
}

// Function to extract specific patient data
const getPatientData = (data) => {
    const patientData = getNonNullValues(data[0])
    const patientInfo = { userExists: true, ...patientData }

    if (data[0]?.cpf) {
        patientInfo.cpfPaciente = data[0].cpf
    }

    if (data[0]?.dataNascimento) {
        patientInfo.dataNascimentoPaciente = data[0].dataNascimento
    }

    return patientInfo
}

// Main function to get data if not null
export const getDataNotNull = (data) => {
    if (!data || data.length === 0) {
        return data
    }
   
    return getPatientData(data)
}

const devicePlataformInfo = {
    options: [],
    header: [
        window.navigator.platform, 
        window.navigator.userAgent, 
        window.navigator.appVersion, 
        window.navigator.vendor, 
        window.opera
    ],
    dataos: [
        { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
        { name: 'Windows', value: 'Win', version: 'NT' },
        { name: 'iPhone', value: 'iPhone', version: 'OS' },
        { name: 'iPad', value: 'iPad', version: 'OS' },
        { name: 'Kindle', value: 'Silk', version: 'Silk' },
        { name: 'Android', value: 'Android', version: 'Android' },
        { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
        { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
        { name: 'Macintosh', value: 'Mac', version: 'OS X' },
        { name: 'Linux', value: 'Linux', version: 'rv' },
        { name: 'Palm', value: 'Palm', version: 'PalmOS' }
    ],
    databrowser: [
        { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
        { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
        { name: 'Safari', value: 'Safari', version: 'Version' },
        { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
        { name: 'Opera', value: 'Opera', version: 'Opera' },
        { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
        { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
    ],
    init: function () {
        var agent = this.header.join(' '),
            os = this.matchItem(agent, this.dataos),
            browser = this.matchItem(agent, this.databrowser);
        
        return { os: os, browser: browser };
    },
    matchItem: function (string, data) {
        var i = 0,
            j = 0,
            regex,
            regexv,
            match,
            matches,
            version;
        
        for (i = 0; i < data.length; i += 1) {
            regex = new RegExp(data[i].value, 'i');
            match = regex.test(string);
            if (match) {
                regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
                matches = string.match(regexv);
                version = '';
                if (matches) { if (matches[1]) { matches = matches[1]; } }
                if (matches) {
                    matches = matches.split(/[._]+/);
                    for (j = 0; j < matches.length; j += 1) {
                        if (j === 0) {
                            version += matches[j] + '.';
                        } else {
                            version += matches[j];
                        }
                    }
                } else {
                    version = '0';
                }
                return {
                    name: data[i].name,
                    version: parseFloat(version)
                };
            }
        }
        return { name: 'unknown', version: 0 };
    }
}


export function detectMobile() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];
  
    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem)
    })
}

export function getDevice() {
    const deviceInfo = { 
        ...devicePlataformInfo.init(), 
        navigator: {
            userAgent : window.navigator.userAgent,
            appVersion: window.navigator.appVersion,
            platform  : window.navigator.platform,
            vendor    : window.navigator.vendor
        }
    }

    return deviceInfo
    //return JSON.stringify(deviceInfo)
}

export function formatDateToString(date) {
    if (!date) return ""; // Se a data for nula ou indefinida, retorna string vazia
  
    const parsedDate = typeof date === "string" ? new Date(date) : date; 
    return format(parsedDate, "dd/MM/yyyy");
}

export function formatDateLocaleBr(date = new Date(), pattern = "yyyy-MM-dd HH:mm:ss") {
    try {
        
   
        const locale = { locale: ptBR }

        const dateParsed = parse(format(date, pattern), pattern, date, locale)
        
        return format(dateParsed, pattern, locale)

    } catch (error) {
        console.log(error, "ERROR NA DATA")
        return date    
    }
}

export function convertDateFormat(date = new Date(), formatFrom = 'dd/MM/yyyy HH:mm', formatTo = 'yyyy-MM-dd HH:mm:ss', now = new Date()) {
    
    const locale = { locale: ptBR }

    const dateParsed = parse(date, formatFrom, now, locale)
    
    return format(dateParsed, formatTo, locale)
}



export const convertToDefaultDate = (dateString, time = ' 00:00') => {
    
    if (!dateString || typeof dateString !== 'string') return dateString 

    const [day, month, year] = dateString?.split('/')
   
    return `${year}-${month}-${day}${time}`
}

export function getUnixTimeFromDate(date) {

    const dateParsed = parse(date, 'dd/MM/yyyy', new Date())
    const d          = new Date(dateParsed)
    const dateUTC    = new Date(d.setHours(0,0,0,0))
    
    return getUnixTime(dateUTC)
}

export function isValidCPF(cpf) {
    var Soma = 0
    var Resto

    var strCPF = String(cpf).replace(/[^\d]/g, '')
  
    if (strCPF.length !== 11)
        return false
  
    if ([
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999',
        ].indexOf(strCPF) !== -1)
        return false

    for (let i=1; i<=9; i++)
        Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);

    Resto = (Soma * 10) % 11

    if ((Resto === 10) || (Resto === 11)) 
        Resto = 0

    if (Resto !== parseInt(strCPF.substring(9, 10)) )
        return false

    Soma = 0

    for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i)

    Resto = (Soma * 10) % 11

    if ((Resto === 10) || (Resto === 11)) 
        Resto = 0

    if (Resto !== parseInt(strCPF.substring(10, 11) ) )
        return false

    return true
}

export function isJsonString(str) {
    try {
        JSON.parse(str)
    } catch (e) {
        return false
    }
    return true
}

export function maskPhone( event ) {
    const value = event.target.value.replace(/[^0-9]/g, "").slice(0, 9);
    event.target.value = value.replace(ONLYPHONE, "$1-$2")
}

export function maskDDD( event ) {
    const value = event.target.value.replace(/[^0-9]/g, "").slice(0, 2);
    event.target.value = value.replace(ONLYDDD, "$1")
}

export function emailMask(event) {
    const value = event.target.value.replace(ONLYEMAIL, '') 
    event.target.value = value
}

export const validateEmail = email => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
}

export const defaultDateFormat = (date, locale = 'sv-SE') => {

    // Create a formatter using the "sv-SE" locale
    const dateFormatter = Intl.DateTimeFormat(locale);

    // Use the formatter to format the date
    const d = dateFormatter.format(date) 
    
    return d
}

export const dateBRtoDefault = date => {

    const dateFormatter = date.split("/").reverse().join("-")

    return dateFormatter 
}

export const getSections = words => {
    
    if (words.length === 0) {
        return []
    }

    return Object.values(
        words.reduce((acc, word) => {
            let firstLetter = words[0].descricaoConvenio.toLocaleUpperCase()
            if (!acc[firstLetter]) {
                acc[firstLetter] = { title: firstLetter, data: [word.descricaoConvenio] }
            } else {
                acc[firstLetter].data.push(word.descricaoConvenio)
            }
            return acc;
        }, {})
    )
}

export const customSections = (array, input) => {
    
    let index  = 0 
    let letter = ''

    if (array.data !== undefined) return array 
    
    const getLastLetter = (k) => {
        letter = letter !== k ? k : letter
        if (letter !== k) {
            index++
        }
    }
    // /console.log(array)
    const words = array.reduce((a, c) => {
        // c[0] should be the first letter of an entry
        
        let k = c[input.label][0].toLocaleUpperCase()
       
        // either push to an existing dict entry or create one
        if ( a[index] !== undefined && a[index]?.title === k) { 
            a[index].data.push(c) 
        } else { 
            a.splice(index, 0, { title: k, data: [c] }) 
        }

        getLastLetter(k)

        return a
    
    }, [])

    return words.reverse()
}

export const getItems = data => {
    if (!data) { return [] }
    
    return data?.reduce( (acc, item) => { 
        
        if (item.isShow !== undefined && !item.isShow) {
           return acc
        } else if (item.idConvenio !== '2') {
            acc.push(item)
        } else if (item.statusPlano === 'A') {
            acc.push(item)
        } else if (item.idEspecialidade) {
            acc.push(item)
        } else if (item.idAgenda) {
            acc.push(item)
        } 
        
        return acc

    }, [])
}

export const getPaginate = (array, page_size, page_number) => {
    page_number = page_number - 1
    return array?.slice(page_number * page_size, page_number * page_size + page_size)
}

export const date = value => {
    
    const parsedDate = typeof value === 'string' ? parse(value, 'dd/MM/yyyy', new Date()) : value
    
    const isValidDate = isValid(parsedDate)

    return { parsedDate, isValidDate}
}

export function capitalizeWords(string) {
    
    if (!string) return string 

    const stringLoserCase = string.toLowerCase()

    return stringLoserCase.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase() })
}

export const getSplitName = (fullname) => {

    const names = fullname?.split(' ') 

    return {
        firstName:  names && names[0] !== undefined ? capitalizeWords(names[0]) : '',
        middleName: names && names[1] !== undefined ? capitalizeWords(names[1]) : '',
        lastName:   names && names[2] !== undefined ? capitalizeWords(names[2]) : '',
    }
}

export const convertDate = date => {
    const dateObj = new Date(date)

    const dateString = dateObj.toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute:'2-digit',
        second:'2-digit'
    }).replace(/\//g, '-')

    //console.log(dateString, 'dateString')

    return dateString
}

export function inviteInCalendar(state) {
    // Create the .ics URL
    let url = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "BEGIN:VEVENT",
        "DTSTART:" + formatDate(state.startDate),
        //"DTEND:" + formatDate(state.endDate),
        "SUMMARY:" + state.title,
        "DESCRIPTION:" + state.description,
        "LOCATION:" + state.location,
        "BEGIN:VALARM",
        "TRIGGER:-PT15M",
        "REPEAT:1",
        "DURATION:PT15M",
        "ACTION:DISPLAY",
        "DESCRIPTION:Reminder",
        "END:VALARM",
        "END:VEVENT",
        "END:VCALENDAR"
    ].join("\n")

    let blob = new Blob([url], {type: 'text/calendar;charset=utf-8'})

    if (/msie\s|trident\/|edge\//i.test(window.navigator.userAgent)) {
        // Open/Save link in IE and Edge
        window.navigator.msSaveBlob(blob, 'download.ics')
    } else {
        // Open/Save link in Modern Browsers
        window.open(encodeURI("data:text/calendar;charset=utf8," + url))
    }

}

function pad(num) {
    // Ensure date values are double digits
    return num < 10 ? "0" + num : num;
}

function formatDate(dateString) {
    let dateTime = new Date(dateString);
    return [
        dateTime.getUTCFullYear(),
        pad(dateTime.getUTCMonth() + 1),
        pad(dateTime.getUTCDate()),
        "T",
        pad(dateTime.getUTCHours()),
        pad(dateTime.getUTCMinutes()) + "00Z"
    ].join("");
}



export const sortBy = (function () {
    const toString = Object.prototype.toString,
        // default parser function
        parse = function (x) { return x; },
        // gets the item to be sorted
        getItem = function (x) {
          var isObject = x != null && typeof x === "object";
          var isProp = isObject && this.prop in x;
          return this.parser(isProp ? x[this.prop] : x);
        };
        
    /**
     * Sorts an array of elements.
     *
     * @param  {Array} array: the collection to sort
     * @param  {Object} cfg: the configuration options
     * @property {String}   cfg.prop: property name (if it is an Array of objects)
     * @property {Boolean}  cfg.desc: determines whether the sort is descending
     * @property {Function} cfg.parser: function to parse the items to expected type
     * @return {Array}
     */
    return function sortby (array, cfg) {
      if (!(array instanceof Array && array.length)) return [];
      if (toString.call(cfg) !== "[object Object]") cfg = {};
      if (typeof cfg.parser !== "function") cfg.parser = parse;
      cfg.desc = !!cfg.desc ? -1 : 1;
      return array.sort(function (a, b) {
        a = getItem.call(cfg, a);
        b = getItem.call(cfg, b);
        return cfg.desc * (a < b ? -1 : +(a > b));
      });
    };
    
  }())
